import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import styles from './Actions.module.sass'
import Limit from './Limit'
import TPSL from './TPSL'
import Market from './Market'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { fetchSpecificMarket, fetchWallets } from 'store/actions'
import { useSelectedMarket } from '..'
import TriggerOrderDropdown from '../../../../components/TriggerOrderDropdown'

// const navigation = ['Limit', 'Market', 'TP/SL']
const navigation = ['Limit', 'Market']
const subNavigations = ['Post Only', 'TP/SL', 'Trigger Order']

const Actions = (props) => {
  const { selectedMarket, setSelectedMarket } = useSelectedMarket();
  const selectedMarketData = useSelector((state) => state.crypto.markets.selectedMarket)
  const { t } = useTranslation()
  const [activeIndex, setActiveIndex] = useState(0)
  const [visibleAction, setVisibleAction] = useState(false)
  const [visible, setVisible] = useState(false)
  const [subNavigation, setSubNavigation] = useState(subNavigations[0])
  const [amount, setAmount] = useState()
  const [totalPrice, setTotalPrice] = useState()

  const dispatch = useDispatch()
  const [baseAsset, setBaseAsset] = useState('')
  const [quoteAsset, setQuoteAsset] = useState('')

  // console.log('subNavigation', subNavigation)
  const { exchangeWallets, loading } = useSelector((state) => state?.walletReducer)
  useEffect(() => {
    const [base, quote] = selectedMarket?.split('-') || ['USDT', 'ETH'];
    setBaseAsset(base || 'USDT');
    setQuoteAsset(quote || 'ETH');
    
    dispatch(fetchSpecificMarket({ baseAsset, quoteAsset }));
    console.log(selectedMarketData,"selectedMarketData")
  }, [selectedMarket,quoteAsset,baseAsset])

  const handleClickBuy = () => {
    setVisibleAction(true)
    setVisible(true)
  }

  const handleClickSell = () => {
    setVisibleAction(false)
    setVisible(true)
  }

  const loadWallets = () => {
    dispatch(fetchWallets())
  }

  useEffect(() => {
    loadWallets({})
  }, [])

  const getWalletBalance = (asset) => {
    const wallet = exchangeWallets?.filter(wallet => wallet?.asset === asset.toLowerCase())?.[0]
    return  wallet?.balance || 0
  }

  return (
    <div className={cn('spot', styles.actions)}>
      <div className={styles.head}>
        <div className={cn('nav', styles.nav)}>
          {navigation.map((x, index) => (
            <button
              className={cn('link', styles.link, {
                [styles.active]: index === activeIndex,
              })}
              onClick={() => setActiveIndex(index)}
              key={index}
            >
              {t(x)}
            </button>
          ))}
          <TriggerOrderDropdown
            key={navigation.length}
            className={styles.dropdown}
            classDropdownHead={cn('link', styles.link, {
              [styles.active]: (navigation.length) === activeIndex,
            })}
            classDropdownArrow={styles.dropdownArrow}
            classDropdownBody={styles.dropdownBody}
            classDropdownOption={styles.dropdownOption}
            value={subNavigation}
            setValue={setSubNavigation}
            options={subNavigations}
            onSelect={() => {
              setActiveIndex(navigation.length)
            }}
            pricePrecision={selectedMarketData?.pricePrecision??6}
            amountPrecision={selectedMarketData?.amountPrecision??6}
          />
        </div>
      </div>
      <div className={cn(styles.wrapper, { [styles.show]: visible })}>
        {activeIndex === 0 && ( 
          <Limit
            contentBuy={`${getWalletBalance(quoteAsset)} ${quoteAsset}`}
            contentSell={`${getWalletBalance(baseAsset)} ${baseAsset}`}
            visible={visibleAction}
            setValue={setVisible}
            pricePrecision={selectedMarketData?.pricePrecision ?? 6}
            amountPrecision={selectedMarketData?.amountPrecision ?? 6}
            selectedMarket={selectedMarket}
          />
        )}
        {activeIndex === 1 && (
          <Market 
            contentBuy={`${getWalletBalance(quoteAsset)} ${quoteAsset}`}
            contentSell={`${getWalletBalance(baseAsset)} ${baseAsset}`}
            amount={amount}
            limit
            totalPrice={totalPrice}
            visible={visibleAction}
            setValue={setVisible}
            selectedMarket={selectedMarket}
            pricePrecision={selectedMarketData?.pricePrecision??6}
            amountPrecision={selectedMarketData?.amountPrecision??6}
          />
        )}
        {activeIndex === 2 && (
          <TPSL
            contentBuy={`${getWalletBalance(quoteAsset)} ${quoteAsset}`}
            contentSell={`${getWalletBalance(baseAsset)} ${baseAsset}`}
            conditionalOrOCO
            triggerPrice
            marketOrder
            limit
            totalPrice={totalPrice}
            visible={visibleAction}
            setValue={setVisible}
            selectedMarket={selectedMarket}
            subNavigation={subNavigation}
            pricePrecision={selectedMarketData?.pricePrecision??6}
            amountPrecision={selectedMarketData?.amountPrecision??6}
          />
        )}
      </div>
      <div className={styles.btns}>
        <button
          className={cn('button-green button-small', styles.button)}
          onClick={() => handleClickBuy()}
        >
          {t('Buy')}
        </button>
        <button
          className={cn('button-red button-small', styles.button)}
          onClick={() => handleClickSell()}
        >
          {t('Sell')}
        </button>
      </div>
    </div>
  )
}

export default Actions
